(function () {
  function initWigyFeatureTabs(root) {
    if (!root || typeof Swiper === 'undefined' || root.dataset.wigyFtInit === 'true') return;
    root.dataset.wigyFtInit = 'true';

    var thumbsEl = root.querySelector('.wigy-ft__thumbs');
    var sliderEl = root.querySelector('.wigy-ft__slider');
    if (!thumbsEl || !sliderEl) return;

    var thumbsSwiper = new Swiper(thumbsEl, {
      slidesPerView: 'auto',
      threshold: 2,
      watchSlidesProgress: true,
      slideToClickedSlide: true
    });

    new Swiper(sliderEl, {
      speed: 300,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      loop: true,
      autoHeight: true,
      watchOverflow: true,
      navigation: {
        nextEl: root.querySelector('.wigy-ft__btn--next'),
        prevEl: root.querySelector('.wigy-ft__btn--prev')
      },
      thumbs: { swiper: thumbsSwiper }
    });
  }

  function initAllWigyFeatureTabs() {
    document.querySelectorAll('.wigy-ft').forEach(function (root) {
      initWigyFeatureTabs(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllWigyFeatureTabs);
  } else {
    initAllWigyFeatureTabs();
  }

  // Soporte para el editor de temas de Shopify: reinicializa al agregar/recargar la sección
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('.wigy-ft');
      if (root) initWigyFeatureTabs(root);
    });
  }
})();
